module.exports = __webpack_public_path__ + "static/media/UI_UX@2x.cfe11a66.png";